<template>
  <div class="content__column content__column--small">
    <h1 class="content__title">Lista de tipos de descuentos</h1>
    <div class="results" v-if="types">
      <div class="results__element" v-for="(type, index) in types" :key="index">
        <div class="results__info">
          <h2 class="results__title" v-text="type.name"></h2>
        </div>
        <div class="results__actions">
          <button @click.prevent="$parent.$emit('view', type.id)" class="btn btn__icon btn__icon--regular results__btn results__btn--view">Ver Tipo</button>
        </div>
      </div>
    </div>
    <div class="information" v-else>
      <p class="information__text">No se encontraron resultados</p>
    </div>
    <confirmation v-if="confirm" @cancel="confirm = false"></confirmation>
  </div>
</template>

<script>
import httpService from '@/core/api/request'
import confirmation from '@/components/layout/confirmation'
export default {
  props: {
    filters: {
      type: String,
      required: false,
      default: function () {
        return ''
      }
    }
  },
  mixins: [
    httpService
  ],
  components: {confirmation},
  data: function () {
    return {
      typeId: null,
      types: null,
      confirm: false
    }
  },
  created: function () {
    this.getTypes()
  },
  mounted: function () {
    this.$on('continue', () => {
      this.confirm = false
      this.proccedToDelete()
    })
  },
  watch: {
    filters: function () {
      this.getTypes()
    },
    '$store.state.elementChanged': function () {
      this.getTypes()
    }
  },
  methods: {
    getTypes: function () {
      let httpRequest = {
        params: '?' + this.filters,
        module: 'discount_types'
      }
      this.get(httpRequest)
        .then(
          types => {
            this.types = types.data
          }
        ).catch(
          () => {
            this.types = null
          }
        )
    },
    deleteGroup: function (id) {
      this.confirm = true
      this.typeId = id
    },
    proccedToDelete: function () {
      let httpRequest = {
        params: '',
        module: 'discount_types'
      }
      this.delete(this.typeId, httpRequest)
        .then(
          response => {
            this.getTypes()
            this.$store.commit('notificate', {
              title: 'TIPO BORRADO',
              text: 'El tipo de descuento ha sido borrado correctamente',
              type: 'success'
            })
          }
        ).catch (
          error => {
            this.$store.commit('notificate', {
              title: 'TIPO NO BORRADO',
              text: 'No se pudo borrar el tipo de descuento seleccionado, por favor intente más tarde',
              type: 'warn'
            })
          }
        )
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/discount_types/list.vue